import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import store from "./store";
import AuthenticationProvider from "./services/auth";
import { addErrorMessage } from "./slice";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      if (!error.response || !error.response.data) {
        store.dispatch(
          addErrorMessage({
            data: { message: "خطایی در شبکه رخ داده است لطفاً چند لحظه دیگر تلاش کنید." },
          })
        );
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      if (!error.response || !error.response.data) {
        store.dispatch(
          addErrorMessage({
            data: { message: "خطایی در شبکه رخ داده است لطفاً چند لحظه دیگر تلاش کنید." },
          })
        );
      }
    },
  }),
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <AuthenticationProvider>
            <App />
          </AuthenticationProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </Provider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
